import { alpha } from '@material-ui/core';
import React from 'react';
import styled from 'styled-components';
import { DSListItem } from '../../../mui/List/ListItem';
import { DSListItemText } from '../../../mui/List/ListItemText';

const StyledDSListItem = styled(DSListItem).attrs({ button: true })<{ $selected: boolean }>`
    ${props =>
        props.$selected &&
        `
        background-color: ${alpha(props.theme.palette.info.light, 0.1)} !important;
    `}
    &:hover {
        background-color: ${props => alpha(props.theme.palette.info.light, 0.05)} !important;
    }
`;

const StyledListItemText = styled(DSListItemText)`
    line-height: 24px;
    padding-left: ${props => props.theme.spacing(2)}px;
    padding-right: ${props => props.theme.spacing(2)}px;
`;

export type InputDropdownListItemProps = {
    label: string;
    onClick: () => void;
    onMouseEnter: () => void;
    selected: boolean;
};

export function InputDropdownListItem({
    label,
    onClick,
    onMouseEnter,
    selected,
}: InputDropdownListItemProps): JSX.Element {
    const ref = React.useRef<HTMLElement>();
    React.useEffect(() => {
        const ele = ref.current;
        if (!ele || !selected) {
            return;
        }
        ele.scrollIntoView({ behavior: 'auto', block: 'nearest', inline: 'nearest' });
    }, [selected]);

    return (
        <StyledDSListItem $selected={selected} innerRef={ref} onClick={onClick} onMouseEnter={onMouseEnter}>
            <StyledListItemText>{label}</StyledListItemText>
        </StyledDSListItem>
    );
}
InputDropdownListItem.displayName = 'InputDropdownListItem';
